module.exports = __webpack_public_path__ + "static/media/image1.0b8e8a61.png";